import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedResidenceContactApiService } from './residence-contact-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class ResidenceContactApiService extends GeneratedResidenceContactApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
